(function () {
  if (window.__hmCartLiveUpdate) return;
  window.__hmCartLiveUpdate = true;

  var cartPath = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/i;
  var syncTimer;
  var keepOpenUntil = 0;
  var fetchGen = 0;
  var lastItemCount = 0;
  var lastAddAt = 0;

  function isShown(el) {
    if (!el) return false;
    if (!el.getClientRects().length) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function findVisibleCartContainer() {
    var nodes = document.querySelectorAll('.cart-container');
    var fallback = null;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.querySelector('.cart_content')) continue;
      fallback = fallback || el;
      if (isShown(el) || isShown(el.querySelector('.mini_cart'))) {
        return el;
      }
    }

    return document.querySelector('.common_div_tec .cart-container') || fallback;
  }

  function preventOutsideClose(event) {
    if (Date.now() < keepOpenUntil) {
      if (event.target && event.target.closest && event.target.closest('.cart-container')) {
        return;
      }
      event.stopImmediatePropagation();
      return;
    }
    document.removeEventListener('click', preventOutsideClose, true);
  }

  function revealMiniCart() {
    document.querySelectorAll('.dropdown_link.active_link, .cart-container.active_link').forEach(function (el) {
      el.classList.remove('active_link');
    });

    var target = findVisibleCartContainer();
    if (!target) return;

    if (window.mobileMenuDrawer && typeof window.mobileMenuDrawer.close === 'function') {
      window.mobileMenuDrawer.close();
    }

    target.classList.add('active_link');
    keepOpenUntil = Date.now() + 900;
    document.addEventListener('click', preventOutsideClose, true);
  }

  function openMiniCart() {
    var fancyboxOpen = document.body.classList.contains('fancybox-active');

    if (fancyboxOpen && window.jQuery && window.jQuery.fancybox) {
      window.jQuery.fancybox.close();
      setTimeout(revealMiniCart, 350);
      return;
    }

    revealMiniCart();
  }

  function applyCart(cart, gen) {
    if (gen !== fetchGen) return;
    if (!cart || typeof cart.item_count !== 'number' || !Array.isArray(cart.items)) return;

    if (cart.item_count === 0 && lastItemCount > 0 && Date.now() - lastAddAt < 2500) {
      return;
    }

    lastItemCount = cart.item_count;

    if (window.PXUTheme && typeof window.PXUTheme.refreshCart === 'function') {
      window.PXUTheme.refreshCart(cart);
    } else {
      document.querySelectorAll('.cart_count').forEach(function (el) {
        el.textContent = String(cart.item_count);
      });
    }

    if (cart.item_count > 0) {
      openMiniCart();
    }
  }

  function syncCart() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var gen = ++fetchGen;
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function (cart) { applyCart(cart, gen); })
        .catch(function () {});
    }, 700);
  }

  function isCartMutation(url) {
    return typeof url === 'string' && cartPath.test(url);
  }

  function noteAdd(url) {
    if (/\/cart\/add/i.test(url)) {
      lastAddAt = Date.now();
    }
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return originalFetch.apply(this, args).then(function (response) {
      try {
        var input = args[0];
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (response && response.ok && isCartMutation(url)) {
          noteAdd(url);
          syncCart();
        }
      } catch (e) {}
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__hmCartUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this.__hmCartUrl)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          noteAdd(this.__hmCartUrl);
          syncCart();
        }
      });
    }
    return originalSend.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'theme:cart:change'].forEach(function (name) {
    document.addEventListener(name, syncCart);
  });
})();
